import enums from '../../helpers/enums';
import formatters from '../../helpers/formatters';
import useApi from '../../helpers/useApi';

import Table from '../../components/Table';

const Jigs = () => {
  const { isLoading, data } = useApi('analytics/production/jigs');

  if (isLoading) {
    return (
      <div>Loading....</div>
    );
  }

  return (
    <Table
      columns={columns}
      data={data.jigs}
      total={data.total}
      filterOpts={{
        filters: [
          {
            name: 'factories',
            type: 'enum',
            enumName: 'factory',
          },
          {
            name: 'modules',
            type: 'enum',
            enumName: 'module',
          },
        ]
      }}
    />
  );
};

export default Jigs;

const columns = [
  {
    key: 'id',
    label: 'UUID',
  },
  {
    key: 'factory_id',
    label: 'Factory',
    formatter: (factoryId) => enums.factory[factoryId].label,
  },
  {
    key: 'count_tests',
    label: 'Tests',
    isOrderable: true,
    defaultOrderDir: 'DESC',
  },
  {
    key: 'count_tests_passed',
    label: 'Passed',
    isOrderable: true,
    defaultOrderDir: 'DESC',
  },
  {
    key: 'count_tests_failed',
    label: 'Failed',
    isOrderable: true,
    defaultOrderDir: 'DESC',
  },
  {
    key: 'count_modules',
    label: 'Modules',
    isOrderable: true,
    defaultOrderDir: 'DESC',
  },
  {
    key: 'avg_tests_per_module',
    label: 'Avg. tests per test module',
    isOrderable: true,
    formatter: formatters.float,
    defaultOrderDir: 'DESC',
  },
];
